import { useMemo } from 'react';
import { SpotlightStep } from './OnboardingSpotlight';

export function useTourSteps(): SpotlightStep[] {
  return useMemo(() => [
    // Welcome - Dashboard
    {
      id: 'welcome',
      target: '[data-tour="dashboard-header"]',
      title: 'spotlight.welcome.title',
      description: 'spotlight.welcome.description',
      placement: 'bottom',
      route: '/dashboard',
    },

    // Sidebar navigation - no route needed, sidebar is always visible
    {
      id: 'sidebar',
      target: '[data-tour="sidebar"]',
      title: 'spotlight.sidebar.title',
      description: 'spotlight.sidebar.description',
      placement: 'right',
    },

    // Applications - Settings
    {
      id: 'applications',
      target: '[data-tour="nav-settings"]',
      title: 'spotlight.applications.title',
      description: 'spotlight.applications.description',
      placement: 'right',
    },

    // Agents in sidebar
    {
      id: 'agents',
      target: '[data-tour="nav-agents"]',
      title: 'spotlight.agents.title',
      description: 'spotlight.agents.description',
      placement: 'right',
    },

    // Agents page - navigate to agents
    {
      id: 'agents-page',
      target: '[data-tour="agents-tabs"]',
      title: 'spotlight.agentsPage.title',
      description: 'spotlight.agentsPage.description',
      placement: 'bottom',
      route: '/agents',
      waitFor: '[data-tour="agents-tabs"]',
    },

    // APM - sidebar is still visible on agents page
    {
      id: 'apm',
      target: '[data-tour="nav-apm"]',
      title: 'spotlight.apm.title',
      description: 'spotlight.apm.description',
      placement: 'right',
    },

    // Logs
    {
      id: 'logs',
      target: '[data-tour="nav-logs"]',
      title: 'spotlight.logs.title',
      description: 'spotlight.logs.description',
      placement: 'right',
    },

    // Infrastructure
    {
      id: 'infrastructure',
      target: '[data-tour="nav-infrastructure"]',
      title: 'spotlight.infrastructure.title',
      description: 'spotlight.infrastructure.description',
      placement: 'right',
    },

    // Scanners
    {
      id: 'scanners',
      target: '[data-tour="nav-scanners"]',
      title: 'spotlight.scanners.title',
      description: 'spotlight.scanners.description',
      placement: 'right',
    },

    // Status & Uptime
    {
      id: 'status-uptime',
      target: '[data-tour="nav-status"]',
      title: 'spotlight.statusUptime.title',
      description: 'spotlight.statusUptime.description',
      placement: 'right',
    },

    // Alerts
    {
      id: 'alerts',
      target: '[data-tour="nav-alerts"]',
      title: 'spotlight.alerts.title',
      description: 'spotlight.alerts.description',
      placement: 'right',
    },

    // ML/Insights
    {
      id: 'ml',
      target: '[data-tour="nav-ml"]',
      title: 'spotlight.ml.title',
      description: 'spotlight.ml.description',
      placement: 'right',
    },

    // Onboarding checklist - back to dashboard
    {
      id: 'onboarding-checklist',
      target: '[data-tour="onboarding-hub"]',
      title: 'spotlight.onboarding.title',
      description: 'spotlight.onboarding.description',
      placement: 'top',
      route: '/dashboard',
      waitFor: '[data-tour="onboarding-hub"]',
    },

    // Finish
    {
      id: 'finish',
      target: '[data-tour="dashboard-header"]',
      title: 'spotlight.finish.title',
      description: 'spotlight.finish.description',
      placement: 'bottom',
    },
  ], []);
}

export default useTourSteps;
